"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHighlightText = exports.setFirsToUpperCase = exports.formatDate = exports.formatAlias = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PagesResults = _interopRequireDefault(require("./PagesResults"));
var _ArticlesResults = _interopRequireDefault(require("./ArticlesResults"));
var _VacanciesResults = _interopRequireDefault(require("./VacanciesResults"));
var _DownloadsResults = _interopRequireDefault(require("./DownloadsResults"));
var _VideosResults = _interopRequireDefault(require("./VideosResults"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
var _EmployeesResults = _interopRequireDefault(require("./EmployeesResults"));
var _AliasResults = _interopRequireDefault(require("./AliasResults"));
var _VorstandResults = _interopRequireDefault(require("./VorstandResults"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-search .title {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  min-height: 80px;\n  align-items: center; }\n  .sia-search .title .bx--loading-overlay {\n    position: relative !important;\n    background-color: transparent !important;\n    transform: scale(0.6); }\n\n.sia-search span {\n  background-color: #ffdb00; }\n\n.sia-search .bx--loading-overlay {\n  position: relative !important;\n  background-color: transparent !important;\n  transform: scale(0.4); }\n\n@media (max-width: 66rem) {\n  .sia-search {\n    padding-inline: 24px; } }\n";
  const fileName = "SIASearch_SIASearch";
  const element = document.querySelector("style[data-sass-component='SIASearch_SIASearch']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const formatAlias = alias => {
  const array = alias.split('/')?.filter(el => el?.length > 0)?.map(el => {
    const el_aux = setFirsToUpperCase(el);
    return el_aux.replaceAll('-', ' ');
  });
  return array.join(' / ');
};
exports.formatAlias = formatAlias;
const formatDate = date => {
  const format = date?.split('-');
  if (format?.length !== 3) return '';
  const day = format[2][0] === '0' ? format[2].slice(1) : format[2];
  const month = format[1][0] === '0' ? format[1].slice(1) : format[1];
  const year = format[0];
  return `${day}.${month}.${year}`;
};
exports.formatDate = formatDate;
const setFirsToUpperCase = text => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
exports.setFirsToUpperCase = setFirsToUpperCase;
const setHighlightText = (string, text) => {
  return string?.replaceAll(text, `<span>${text}</span>`)?.replaceAll(text.toLowerCase(), `<span>${text.toLowerCase()}</span>`)?.replaceAll(text.toUpperCase(), `<span>${text.toUpperCase()}</span>`)?.replaceAll(setFirsToUpperCase(text), `<span>${setFirsToUpperCase(text)}</span>`);
};
exports.setHighlightText = setHighlightText;
const SIASearch = _ref => {
  let {
    lang,
    translate,
    text,
    pageItems,
    articleItems,
    vacancyItems,
    mediaItems,
    videoItems,
    employeeItems,
    vorstandItems,
    aliasItems
  } = _ref;
  const data = [...(pageItems || []), ...(articleItems || []), ...(vacancyItems || []), ...(mediaItems || []), ...(videoItems || []), ...(employeeItems || []), ...(vorstandItems || []), ...(aliasItems || [])];
  const arrays = [pageItems, articleItems, vacancyItems, mediaItems, videoItems, employeeItems, vorstandItems, aliasItems];
  const isLoading = arrays.includes(null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-search"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title sia-margin-05-top"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null) : /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-12"
  }, data.length > 0 ? data.length : '', ' ', data.length === 0 ? translate('cms.search.no_results') : data.length === 1 ? translate('cms.search.result') : translate('cms.search.results'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-margin-04-top sia-margin-04-bottom sia-border-01-bottom"
  }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [{
      link: {
        original_url: `/${lang}/agenda?name=${text}`,
        title: translate('cms.search.agenda_results')
      }
    }],
    lang: lang,
    isCMS: false
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "results sia-margin-05-top"
  }, vorstandItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_VorstandResults.default, {
    vorstandItems: vorstandItems,
    lang: lang,
    translate: translate
  }), vorstandItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), employeeItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_EmployeesResults.default, {
    employees: employeeItems,
    lang: lang,
    translate: translate
  }), employeeItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), pageItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_PagesResults.default, {
    pages: pageItems,
    lang: lang,
    text: text,
    translate: translate
  }), pageItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), aliasItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_AliasResults.default, {
    aliases: aliasItems,
    lang: lang,
    translate: translate
  }), aliasItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), mediaItems && Object.entries(mediaItems)?.length > 0 && /*#__PURE__*/_react.default.createElement(_DownloadsResults.default, {
    downloads: mediaItems,
    lang: lang,
    text: text,
    translate: translate
  }), mediaItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), videoItems && Object.entries(videoItems)?.length > 0 && /*#__PURE__*/_react.default.createElement(_VideosResults.default, {
    videos: videoItems,
    lang: lang,
    text: text,
    translate: translate
  }), videoItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), articleItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_ArticlesResults.default, {
    articles: articleItems,
    lang: lang,
    text: text,
    translate: translate
  }), articleItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), vacancyItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_VacanciesResults.default, {
    vacancies: vacancyItems,
    lang: lang,
    text: text,
    translate: translate
  }), vacancyItems === null && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null)));
};
var _default = exports.default = SIASearch;